export default __webpack_public_path__ + "static/media/risk.babff337.jpg";